import { Component, Vue, Prop } from "vue-property-decorator";
import { AxiosError } from "axios";
import ErrorHandler from "@/support/ErrorHandler";
import { EnglishRules, Rules } from "@/support/ValidationRules";
import { Supplier } from "@/models/Supplier";
import {filtered_country_list} from "@/support/Countries";

@Component<CreateDialog>({})
export default class CreateDialog extends Vue {
  @Prop({ default: null })
  protected supplier!: Supplier;

  protected newSupplier: Supplier = new Supplier();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;
  protected countries: string[] = filtered_country_list;

  mounted() {
    if (this.supplier) {
      this.newSupplier = this.supplier.clone();
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }

  protected close() {
    this.$emit("input", false);
    this.clear();
  }

  protected createOrUpdate() {
    if (this.newSupplier.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if (!this.newSupplier) {
      return;
    }

    this.newSupplier
      .update()
      .then((supplier: Supplier) => {
        this.isLoading = false;
        this.$emit("supplierUpdated", supplier);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.canSaveSupplier) {
      return;
    }

    this.isLoading = true;
    this.newSupplier
      .create()
      .then((supplier: Supplier) => {
        this.isLoading = false;
        this.$emit("supplierCreated");
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get canSaveSupplier() {
    if (
      this.newSupplier &&
      this.newSupplier.name &&
      this.newSupplier.name.length > 0 &&
      this.newSupplier.short_name &&
      this.newSupplier.short_name.length > 0
    ) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    return this.supplier
      ? 'Edit'
      : 'Add';
  }

  protected clear() {
    this.newSupplier = new Supplier();
  }
}
